"use strict";

// fade in on scroll

const targets = new Set([
  ...document.querySelectorAll("#mainContent .shopify-section > div:not(#hp-hero) > div"),
]);

function observerCallback(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('js-fade-up-active');
    }
  });
}
const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0,
};
const observer = new IntersectionObserver(observerCallback, observerOptions);

for (const target of targets) {
  target.classList.add("js-fade-up");
  observer.observe(target);
}